import PontoForm from './PontoForm';
import GerarPontoForm from './GerarPontoForm';

export default { PontoForm, GerarPontoForm };
